/**
 * Utility higher-level error categories with their intending meaning.
 *
 * Use these categories to translate errors to more meaningful feedback
 * to the user. E.g. write a mapper that maps the error to one of these
 * categories, and then provide a corresponding message to display to user.
 *
 */
export enum ErrorCategory {
  /** No internet connection */
  INTERNET_DOWN = 'internet-down',
  /** No response from server (might be a local network issue)  */
  SERVER_NO_RESPONSE = 'server-no-response',
  /** Transient server problem (a repeated request might me successful) */
  SERVER_PROBLEM_TRANSIENT = 'server-problem-transient',
  /** Server problem. A repeated request will NOT be successful. */
  SERVER_PROBLEM_FATAL = 'server-problem-fatal',
  /** No response from server within designated time limit */
  REQUEST_TIME_OUT = 'server-time-out',
    /**
   * A problem with the response. Either the server misbehaved and sent
   * am illegal/non-standard response or the client doesn't know how to
   * handle/interpret the response.
   */
  RESPONSE_PROBLEM = 'response-problem',
  /**
   * A problem with the request (e.g. you called a non-existing method on
   * the server), and the server informed you that the request is wrong.
   * This indicates a problem on the _client_ side of things, which may
   * not be in sync with the remote api.
   */
  REQUEST_PROBLEM = 'request-problem',
  /**
   * A problem specifically with the parameter _values_ in the request
   * e.g. a value (email-address, etc.) did not pass validation
   * on the server. A narrowed down version of 'REQUEST_PROBLEM'
   * This error means a new request might pass if you change
   * the values. If the server supplies additional information in
   * a way that you known how to read, this could potentially be used
   * to drill down to the problem fields and indicate corrective
   * actions to the user.
  */
  REQUEST_INVALID_PARAM_VALUES = 'request-invalid-param-values',
  /** The server refused authentication ('log in') due to wrong credentials */
  AUTHENTICATION_FAILED = 'authentication-failed',
  /**
   * The server does not permit the (authenticated) user to perform the
   * requested operation.
   */
  NOT_AUTHORIZED = 'not-authorized',
  /** Unknown problem  */
  UNKNOWN = 'unknown'
}
